import style from './article-preview-medium.module.scss';
import Image from 'next/legacy/image';
import Link from 'next/link';
import { IArticle } from '@models/article.interface';
import ReadingTimeBlock from '@components/blog/reading-time-block/reading-time';
import DOMPurify from 'dompurify';
import { useEffect, useState } from 'react';
interface ArticlePreviewMediumProps {
  article: IArticle;
}

const ArticlePreviewMedium = ({ article }: ArticlePreviewMediumProps) => {
  const [articleDiscription, setArticleDiscription] = useState<string>('');
  useEffect(() => {
    setArticleDiscription(
      DOMPurify.sanitize(article.description, { FORBID_ATTR: ['style', 'id'] }),
    );
  }, [article.description]);

  return (
    <Link scroll={false} href={`/blog/${article.slug}`} className={style.blogs__item}>
      <div className={style.blogs__image}>
        <Image sizes="1024px" layout={'fill'} src={article.posterUrl} alt={article.header} />
      </div>
      <div className={style.blogs__content}>
        <div className={style.blogs__content__title}>{article.header}</div>
        <div className={style.blogs__content__subtitle}>
          <div
            dangerouslySetInnerHTML={{
              __html: articleDiscription,
            }}
          ></div>
        </div>
        <ReadingTimeBlock readingTime={article.readingTime} articleLabel={article.label} />
      </div>
    </Link>
  );
};

export default ArticlePreviewMedium;
